import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AuditHistoryConfig } from 'src/app/Shared-Module/audit-history-grid/audit-history-grid.component';

export interface TabConfiguration {
  showSevaProfile?: boolean;
  showVisitingSeva?: boolean;
  showPthView: boolean;
  showCocReference?: boolean;
  showNotes?: boolean;
  showAuditHistory?: boolean;
  showAction?: boolean;
}

@Component({
  selector: 'app-approval-matrix-preview',
  templateUrl: './approval-matrix-preview.component.html',
  styleUrls: ['./approval-matrix-preview.component.scss']
})
export class ApprovalMatrixPreviewComponent implements OnInit, OnChanges {

  constructor(private toastr: ToastrService,  ){}
  
  @Input() tabConfig: TabConfiguration = {
    showSevaProfile: false,
    showPthView: false
  };
  
  private defaultTabConfig: TabConfiguration = {
    showSevaProfile: true,
    showVisitingSeva: true,
    showPthView: true,
   
    showCocReference: false,
    showNotes: true,
    showAuditHistory: true,
    showAction: true
  };
  
  get effectiveTabConfig(): TabConfiguration {
    // Merge parent config with defaults, but parent values take precedence
    return {
      showSevaProfile: this.tabConfig.showSevaProfile !== undefined ? this.tabConfig.showSevaProfile : this.defaultTabConfig.showSevaProfile,
      showVisitingSeva: this.tabConfig.showVisitingSeva !== undefined ? this.tabConfig.showVisitingSeva : this.defaultTabConfig.showVisitingSeva,
      showPthView: this.tabConfig.showPthView !== undefined ? this.tabConfig.showPthView : this.defaultTabConfig.showPthView,
      showCocReference: this.tabConfig.showCocReference !== undefined ? this.tabConfig.showCocReference : this.defaultTabConfig.showCocReference,
      showNotes: this.tabConfig.showNotes !== undefined ? this.tabConfig.showNotes : this.defaultTabConfig.showNotes,
      showAuditHistory: this.tabConfig.showAuditHistory !== undefined ? this.tabConfig.showAuditHistory : this.defaultTabConfig.showAuditHistory,
      showAction: this.tabConfig.showAction !== undefined ? this.tabConfig.showAction : this.defaultTabConfig.showAction
    };
  }
  
  currentStep: string = 'Seva Profile';
  userData:any ={}
  isJsonShow = environment.isJsonShow;  
  auditHistoryConfig: AuditHistoryConfig = {
    apiUrl: 'AuditHistory/GetAuditHistoryODataAsync'
  };

  ngOnInit(): void {
     this.userData = history.state.rowData;
     this.buildAuditHistoryConfig();
     this.setInitialStep();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabConfig'] && !changes['tabConfig'].firstChange) {
      this.setInitialStep();
    }
  }

  setInitialStep(): void {
    // Set the first visible tab as the current step using effective config
    const config = this.effectiveTabConfig;
    if (config.showSevaProfile) {
      this.currentStep = 'Seva Profile';
    } else if (config.showVisitingSeva) {
      this.currentStep = 'Visiting Seva';
    } else if (config.showPthView) {
      this.currentStep = 'PTH View';
    } else if (config.showCocReference) {
      this.currentStep = 'COC Reference';
    } else if (config.showNotes) {
      this.currentStep = 'Notes';
    } else if (config.showAuditHistory) {
      this.currentStep = 'Audit History';
    } else if (config.showAction) {
      this.currentStep = 'Action';
    }
  }

  buildAuditHistoryConfig(): void {
    if (this.userData) {
      let apiUrl = 'AuditHistory/GetAuditHistoryODataAsync';
      const params: string[] = [];
      
      if (this.userData.SevaProfileDisplayUID) {
        params.push(`sevaProfileUID=${this.userData.SevaProfileDisplayUID}`);
      }
      
      if (this.userData.ApplicationGuid) {
        params.push(`applicationGuid=${this.userData.ApplicationGuid}`);
      }
      
      if (params.length > 0) {
        apiUrl += `?${params.join('&')}`;
      }
      
      this.auditHistoryConfig = {
        apiUrl: apiUrl
      };
    }
  }

  onStepChange(event: any) {
    this.currentStep = event.step.label?.trim();
  }


}
